module.exports = __webpack_public_path__ + "media/images/andriod-code-2446fb0079f98d3773330c4d2083b0ac.png";